import { useState, useCallback } from 'react'
import { MediaPopup } from '../components/Popup'
import { useAddMediaFileMutation } from 'src/redux/Api/mediaApi'

export const NewMedia = () => {
  const [newMediaPopup, setNewMediaPopup] = useState(false)
  const [files, setFiles] = useState<FileList | null>(null)
  const [addNewMedia] = useAddMediaFileMutation()

  const handleNewMedia = useCallback( async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (files) {
      const formData = new FormData()
      Array.from(files).forEach((img) => {
        formData.append('files', img)
      })
      try {
        await addNewMedia(formData)
        setNewMediaPopup(false)
      } catch (error) {
        console.error(error)
      }
    }
  }, [files, addNewMedia])

  return (
    <>
      <button className="btn" onClick={() => setNewMediaPopup(true)}>
        Add new media
      </button>
      {newMediaPopup && <MediaPopup handleNewMedia={handleNewMedia} setFiles={setFiles} setNewMediaPopup={() => setNewMediaPopup(false)} />}
    </>
  )
}
